import React from 'react';
import { Navigation } from '../navigation';
import { cn } from '../../utils';

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function MainLayout({ children, className }: LayoutProps) {
  return (
    <div className={cn('min-h-screen bg-secondary-50 dark:bg-secondary-900', className)}>
      <Navigation />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {children}
      </div>
    </div>
  );
}

// Re-export the new sidebar layout
export { SidebarLayout } from './sidebar-layout';

export function PageHeader({ 
  title, 
  subtitle, 
  actions, 
  className 
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mb-8', className)}>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-secondary-900 dark:text-white">{title}</h1>
          {subtitle && (
            <p className="mt-2 text-secondary-600 dark:text-secondary-400">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center space-x-3">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export function Card({ 
  children, 
  className,
  padding = true 
}: {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}) {
  return (
    <div className={cn(
      'bg-white dark:bg-secondary-800 rounded-lg border border-secondary-200 dark:border-secondary-700 shadow-sm',
      padding && 'p-6',
      className
    )}>
      {children}
    </div>
  );
}
